import React, { useContext, useState } from 'react';
import { Paper, Grid, TextField, Button, Typography } from '@material-ui/core';
import { DataTable, Notifications } from '../../../../shared';
import { UserContext } from '../../../../contexts/UserContext';
import { fbmApi as api } from '../../../../api/fbm';
import dayjs from '~/utils/dayjsConfig';

const ViewOrderPackagingData = () => {
    const { fbmAccount } = useContext(UserContext);
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const [reportButtonText, setReportButtonText] = useState('Run Report');

    const [reportStartDate, setReportStartDate] = useState(dayjs().subtract(7, 'days').format('YYYY-MM-DD'));
    const [reportEndDate, setReportEndDate] = useState(dayjs().format('YYYY-MM-DD'));

    const handleReportStartDateChange = (event) => {
        setReportStartDate(event.target.value);
    };

    const handleReportEndDateChange = (event) => {
        setReportEndDate(event.target.value);
    };

    let columns = [
        { accessor: 'id', csvAccessor: 'id', Header: 'Order ID', width: 160 },
        { accessor: 'fbm_order_num', csvAccessor: 'fbm_order_num', Header: 'FBM Order Num', width: 180 },
        { accessor: 'heat_index', csvAccessor: 'heat_index', Header: 'Heat Index', width: 180 },
        { accessor: 'name', csvAccessor: 'name', Header: 'Box Size', width: 180 },
        { accessor: 'liner', csvAccessor: 'liner', Header: 'Liner', width: 180 },
    ];

    const handleRunReportClick = () => {
        getAndRenderReportData();
    };

    const getAndRenderReportData = async () => {
        setReportButtonText('Loading...');
        setRows([]);
        setNotification({ text: null, level: null });

        try {
            const response = await api.getOrderPackagingData(fbmAccount.fbmAccountName, reportStartDate, reportEndDate);

            if (response.status === false) {
                setNotification({ text: 'No entries found: ' + response.msg, level: 'error' });
                setRows([]);
            } else {
                setRows(response.data.rows || []);
                if (response.data.rows && response.data.rows.length === 0) {
                    setNotification({ text: 'No data found for the selected date range.', level: 'info' });
                }
            }
        } catch (error) {
            setNotification({ text: 'Error loading data: ' + error.toString(), level: 'error' });
            setRows([]);
        } finally {
            setReportButtonText('Run Report');
        }
    };

    return (
        <Paper style={{ padding: '16px' }}>
            <Notifications options={notification} />

            <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={12}>
                    <Typography variant="h6">{fbmAccount.companyName} - Order Packaging Data</Typography>
                </Grid>

                <Grid item>
                    <TextField
                        id="reportStartDate"
                        label="Start Date"
                        type="date"
                        value={reportStartDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        disabled={reportButtonText === 'Loading...'}
                        onChange={handleReportStartDateChange}
                    />
                </Grid>

                <Grid item>
                    <TextField
                        id="reportEndDate"
                        label="End Date"
                        type="date"
                        value={reportEndDate}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        disabled={reportButtonText === 'Loading...'}
                        onChange={handleReportEndDateChange}
                    />
                </Grid>

                <Grid item>
                    <Button
                        id="runReport"
                        onClick={handleRunReportClick}
                        color="secondary"
                        variant="contained"
                        disabled={reportButtonText === 'Loading...'}
                    >
                        {reportButtonText}
                    </Button>
                </Grid>
            </Grid>

            {rows.length === 0 && reportButtonText !== 'Loading...' && !notification.text && (
                <Typography variant="body1" style={{ marginTop: '16px' }}>
                    Select a date range and click 'Run Report' to fetch order packaging data.
                </Typography>
            )}

            <br />

            <DataTable
                csvExport={rows.length > 0 && reportButtonText === 'Run Report'}
                csvExportFileName="order-packaging-data"
                csvExportHeadersUseAccessor={true}
                csvExportAccessor="csvAccessor"
                columns={columns}
                data={rows}
                editable={false}
            />
        </Paper>
    );
};

export { ViewOrderPackagingData };
